import { Link } from "react-router-dom";
import PersonSkillListItem from "../ListItems/PersonSkillListItem";
import BreadCrumb from "../Controls/BreadCrumb";
import UserData from "../Controls/UserData";
import SkillSearch from "../Controls/SkillSearch";
import Help from "../Controls/Help";

export default function PersonSkills() {
   const userData = UserData.UserData() || {};
   let skills = userData.skills || [];
   let personSkills = [...(userData.personSkills || [])].sort((a, b) => {
      return (a.SkillName || "") < (b.SkillName || "") ? -1 : 1;
   });

   return (
      <div className="pagebody skillListPage">
         <BreadCrumb props={["Skills"]} />
         <div className="tabbody">
            <h2>Skills</h2>
            <Help id="2138" />

            <SkillSearch label="Skill Search" className="right" personEdit={true} />
            <p>
               <Link to="/skillTests">Take a skill test</Link>
               {" · "}
               <Link to="/skillQuestions">Community questions</Link>
            </p>

            <ul className="TopList SkillList">
               {personSkills ? (
                  personSkills.map((personSkill) => {
                     return (
                        <PersonSkillListItem
                           key={personSkill.ID}
                           personSkill={personSkill}
                           skill={skills.find((s) => s.ID === personSkill.SkillID)}
                        />
                     );
                  })
               ) : (
                  <p>You have not added any skills</p>
               )}
            </ul>
         </div>
      </div>
   );
}
